import React, { useState } from "react";

import PageDefault from "../../components/pageDefault";
import FormDataContainer from "../../components/formDataContainer";
import FormAdministradores from "./formAdministradores";
import GridAdministradores from "./gridAdministradores";
import { AdministradorProvider } from "./context";
import "./style.css";
import ModalNewUser from "../../components/modalNewUser";

function Administradores() {
  const [dadosAdministradoresSelecionado, setDadosAdministradoresSelecionado] =
    useState({});
  const [atualizar, setAtualizar] = useState(false);
  const [visibleBlockingPanel, setVisibleBlockingPanel] = useState(true);
  const [isShowModalNewUser, setIsShowModalNewUser] = useState(false);

  const contexto = {
    estado: "I",
    atualizarGrade: (atualizar) => {
      setAtualizar(atualizar);
    },
    precisaAtualizar: atualizar,
    data: dadosAdministradoresSelecionado,
    setData: (newData) => {
      setDadosAdministradoresSelecionado(newData);
    },
    blockingPanel: visibleBlockingPanel,
    setVisibleBlockingPanel: (isVisible) => {
      setVisibleBlockingPanel(isVisible);
    },
  };

  return (
    <PageDefault>
      <AdministradorProvider value={contexto}>
        <ModalNewUser
          visible={isShowModalNewUser}
          setIsShowModalNewUser={setIsShowModalNewUser}
          isAdministrador
          isDoctor={false}
        />
        <FormDataContainer
          title={"Administradores"}
          btnTitle="Novo"
          visibleBlocking={visibleBlockingPanel}
          setVisibleBlocking={setVisibleBlockingPanel}
          setIsShowModalNewUser={setIsShowModalNewUser}
          isCreateUserByMail
        >
          <FormAdministradores />
        </FormDataContainer>
        <GridAdministradores />
      </AdministradorProvider>
    </PageDefault>
  );
}

export default Administradores;
